import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import TextWithTip from "../../../../components/TextWithTip";
import { formatNumber, formatNumberOneDecimal } from "../../shared/reportUtil";
import { AdminReportsResponse, ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { EssaysAndDraftsRow } from "./adminUsageReportApiSlice";

export function EssaysAndDraftsTable(props: {
	className: string;
	level: ReportLevel;
	data: AdminReportsResponse<EssaysAndDraftsRow>;
	hideRows: boolean;
	setDistrictFilter: (districtId: number) => void;
	setSchoolFilter: (schoolId: number) => void;
}) {
	const hasData = props.data && props.data.rows.length > 0;

	function changeFilters(id: number) {
		if (props.level === ReportLevel.State) {
			props.setDistrictFilter(id);
		} else if (props.level === ReportLevel.District) {
			props.setSchoolFilter(id);
		}
	}

	const nameTemplate = (rowData: EssaysAndDraftsRow) => {
		return (
			<a
				className={`${props.level === ReportLevel.School ? "" : "link"}`}
				onClick={() => changeFilters(rowData.id)}>
				{rowData.name}
			</a>
		);
	};

	const teacherTemplate = (rowData: EssaysAndDraftsRow) => {
		return (
			<span>
				<TextWithTip uniqueName={`teachers-${rowData.id}`} text={rowData.teachers} />
			</span>
		);
	};

	const essayCountTemplate = (rowData: EssaysAndDraftsRow) => {
		return formatNumber(rowData.essayCount);
	};

	const draftCountTemplate = (rowData: EssaysAndDraftsRow) => {
		return formatNumber(rowData.draftCount);
	};

	const averageTemplate = (rowData: EssaysAndDraftsRow) => {
		return formatNumberOneDecimal(rowData.averageNumberOfDraftsPerEssay);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column
					footer={`${props.level}-Wide`}
					footerClassName="font-medium !text-right"
					colSpan={props.level === ReportLevel.School ? 2 : 1}
				/>
				<Column
					footer={formatNumber(props.data.totals.essayCount)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumber(props.data.totals.draftCount)}
					footerClassName="font-medium"
				/>
				<Column
					footer={formatNumberOneDecimal(props.data.totals.averageNumberOfDraftsPerEssay)}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	return (
		<DataTable
			value={props.hideRows ? [] : props.data.rows}
			dataKey="id"
			loading={props.data.rows == undefined}
			emptyMessage="No results found"
			pt={{
				// Targets the container of the "No results found" message for hiding it
				emptyMessage: {
					style: { display: !props.hideRows ? "table-row" : "none" },
				},
			}}
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header={reportSubLevelName(props.level)}
				body={nameTemplate}
				sortable
				sortField="name"></Column>
			{props.level === ReportLevel.School && (
				<Column
					header="Teacher(s)"
					body={teacherTemplate}
					className="!max-w-52"
					sortable
					sortField="teachers"></Column>
			)}
			<Column
				header="Number of Essays"
				body={essayCountTemplate}
				sortable
				sortField="essayCount"></Column>
			<Column
				header="Number of Drafts"
				body={draftCountTemplate}
				sortable
				sortField="draftCount"></Column>
			<Column
				header="Avg Drafts Per Essay"
				body={averageTemplate}
				sortable
				sortField="averageNumberOfDraftsPerEssay"></Column>
		</DataTable>
	);
}
